import { Avatar, Box, IconButton, SxProps, Typography } from '@mui/material'
import { InsertDriveFileOutlined as FileAttachmentIcon, Close as CrossCloseIcon } from '@mui/icons-material'

interface FileDropzoneAttachmentPreviewProps {
    file?: File
    sx?: SxProps
    onClose: () => void
}

export default function FileDropzoneAttachmentPreview({
    file,
    sx,
    onClose,
}: FileDropzoneAttachmentPreviewProps): JSX.Element {
    return (
        <Box
            display='flex'
            alignItems='center'
            sx={{
                backgroundColor: (theme) => theme.palette.background.paper,
                border: `1px solid`,
                borderRadius: '12px',
                py: 4,
                px: 2,
                height: '48px',
                ...sx,
            }}
        >
            <Avatar sx={{ mr: 2 }}>
                <FileAttachmentIcon sx={{ fontSize: 20 }} />
            </Avatar>
            <Typography variant='subtitle2' sx={{ fontWeight: 500 }}>
                {file?.name}
            </Typography>
            <IconButton size='small' color='secondary' sx={{ marginLeft: 'auto' }} onClick={onClose}>
                <CrossCloseIcon />
            </IconButton>
        </Box>
    )
}
